export const convertStringToArray = (value: string, separator: string = ','): number[] => {
    let values: number[] = [];
    
    if (value !== "") {
        values = value.split(separator).map(value => Number(value));
    }

    return values;
}